"use client";

import { usePathname } from "next/navigation";
import { useMemo, useState } from "react";
import GroupCard from "../CommunityGroupCard/CommunityGroupCard";
import { communityFeedTranslations } from "@/lib/pagesTranslations";

type Group = {
  title: string;
  description: string;
  link: string;
  languages: string[];
};

const groups: Group[] = [
  {
    title: "Comunidade - GenauHub na Alemanha",
    description:
      "Participe do nosso grupo oficial para se conectar com outros brasileiros, tirar dúvidas, compartilhar dicas e ficar por dentro de tudo sobre o GenauHub.",
    link: "https://chat.whatsapp.com/FY8IP90eCdt7rNzDlDrXK5",
    languages: ["PT"],
  },
];

export default function CommunityFeed() {
  const pathname = usePathname();
  const [selectedLang, setSelectedLang] = useState("ALL");

  // Get locale from pathname (e.g., /pt/community or /en/community)
  const locale = useMemo(() => {
    if (pathname?.startsWith("/en")) return "en";
    return "pt";
  }, [pathname]);

  const t = communityFeedTranslations[locale] ?? communityFeedTranslations["pt"];
  const availableLanguages = ["ALL", "PT", "EN", "DE"];
  const filteredGroups = groups.filter(
    (group) => selectedLang === "ALL" || group.languages.includes(selectedLang)
  );

  return (
    <>
      <h1 className="text-2xl md:text-3xl text-[#1B475D] font-bold mb-3 md:mb-6">
        {t.pageHeading}
      </h1>
      <div className="w-full grid grid-cols-1 gap-6">
        <div>
          <h2 className="text-xl font-semibold mb-4 text-[#1B475D]">{t.heading}</h2>

          {/* Language Filter */}
          <div className="mb-6 flex flex-wrap gap-3">
            {availableLanguages.map((lang) => (
              <button
                key={lang}
                onClick={() => setSelectedLang(lang)}
                className={`px-3 py-1 text-sm font-medium rounded-full border transition ${
                  selectedLang === lang
                    ? "bg-[#8EBD9D] text-[#1B475D] border-[#4E9B75]"
                    : "border-[#D3DC7C] text-[#1B475D] hover:bg-[#EEE5C2]"
                }`}
              >
                {lang === "ALL" ? t.allLanguages : lang}
              </button>
            ))}
          </div>

          {/* Groups */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            {filteredGroups.map((group) => (
              <GroupCard key={group.title + group.link} {...group} />
            ))}
            {filteredGroups.length === 0 && (
              <p className="text-[#1B475D] opacity-60 italic">{t.noGroups}</p>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
